module.exports = __webpack_public_path__ + "media/images/front/brands/avant_garde/avant_garde_header_m-36da5dfbcf8b1b46e681431e4272312f.webp";